import {
    Button,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    UncontrolledTooltip
} from "reactstrap";
import React, {useState} from "react";

const DeleteButton = ({idx,id,deleteFunc,text}) => {
    const [show,setModal] = useState(false);
    const onHide =()=>{

        setModal(!show)
    };
    const [AllowDelete,SetDelete] = useState(false)

    return (
        <span>

            <Button
                className="btn-link"
                color="danger"
                data-toggle="tooltip"
                id={`remove-${idx}`}
                size="sm"
                type="button"
                onClick={(e) => {
                    onHide()
                }}
                aria-label={'Usuń'}
            >
                <i className="fas fa-trash-alt"></i>
            </Button>
            <UncontrolledTooltip
                delay={0}
                placement="top"
                target={`remove-${idx}`}
            >
                Usuń
            </UncontrolledTooltip>



            {/* <Modal toggle={onHide} isOpen={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
           style={{opacity:1}}
    >
      <ModalHeader>
          Czy napewno chcesz usunąć {text}?
      </ModalHeader>
      <ModalBody>
        <FormGroup className="pb-2 justify-content-md-center" check>
          <Label check>
            <Input type="checkbox" name="deleteModal" id="deleteModal" checked={AllowDelete} onClick={() => SetDelete(!AllowDelete)}
                            />
            <span className="form-check-sign"/>
            Potwierdź usunięcie
          </Label>
      </FormGroup>
      </ModalBody>
      <ModalFooter>
          <Button color={"success"} onClick={e=>{SetDelete(true);onHide();}} >Anuluj</Button>
        <Button color={"danger"} disabled={!AllowDelete} onClick={e=>{deleteFunc(id);onHide();}}>Usuń</Button>

      </ModalFooter>
    </Modal> */}

            <Modal isOpen={show} toggle={onHide}>
                <div className="modal-header">
                    <button className="close" type="button" onClick={()=>onHide()} >
                    <span>×</span>
                    </button>
                    <h5 className="modal-title text-center" id="exampleModalLabel" >
                        Ostrzeżenie
                    </h5>
                </div>
                <div className="modal-body">
                    Czy napewno chcesz usunąć {text}
                </div>
                <div className="modal-footer">
                    <div className="left-side">
                        <Button className="btn-link" color="danger" type="button" onClick={() => {
                            deleteFunc(id);
                            onHide();
                        }} > Tak </Button>
                    </div>
                    <div className="divider" />
                    <div className="right-side">
                    <Button className="btn-link" color="default" type="button" onClick={()=> {SetDelete(true);onHide();}} >
                        Anuluj
                    </Button>
                    </div>
                </div>
            </Modal>
        </span>
    );
}
export default DeleteButton